import React from 'react';
import PropTypes from 'prop-types';
import LabeledRadioWithDescription from '../base/LabeledRadioWithDescription/LabeledRadioWithDescription';
import {COMPANY_GLYPH, USER_GLYPH} from '../../const/Glyphicons';
import Title from '../base/Title/Title';
import textTranslates from './translate.json';
import './Customer.scss';

const CustomerType = (props) => {
    return(
        <div className="col-xs-12 ">
            <Title
                id="cutomerTypeTitle"
                title= {textTranslates.cutomerTypeTitle}/> 
            <div className="col-xs-12 labeled-radio customer-picker-bold">
                {props.customerTypes
                    .filter(customerType=> 
                        customerType.display === true)
                    .map(customerType => { 
                        let glyph = COMPANY_GLYPH;
                        if(customerType.value==="PrivatePerson") {
                            glyph = USER_GLYPH;
                        }
                        return(
                            <LabeledRadioWithDescription
                                checked={props.customerType.value === customerType.value}
                                description={customerType.description}
                                glyph={glyph}
                                id={customerType.value}
                                customerType={customerType}
                                key={customerType.value}
                                label={customerType.displayName}
                                name="customerType"
                                value={customerType.value}
                                onRadioClick={props.onRadioClick} />
                        );
                    })
                }
            </div>
        </div>
    );
};

CustomerType.propTypes = {
    customerTypes: PropTypes.array,
    customerType: PropTypes.object,
    id: PropTypes.string,
    label: PropTypes.string,
    onRadioClick: PropTypes.func
};

export default CustomerType;


// WEBPACK FOOTER //
// ./src/components/Customer/CustomerType.js